var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingIconBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "premiumIcon",
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M26.156 16.462c.056-.468.094-.956.094-1.462s-.038-.994-.113-1.463l3.17-2.475a.775.775 0 0 0 .187-.956l-3-5.194c-.188-.337-.581-.45-.919-.337l-3.731 1.5a10.985 10.985 0 0 0-2.532-1.463L18.75.638A.749.749 0 0 0 18 0h-6a.73.73 0 0 0-.731.637l-.563 3.975c-.918.375-1.762.882-2.531 1.463l-3.731-1.5a.741.741 0 0 0-.919.337l-3 5.194c-.188.338-.113.732.188.957l3.168 2.474A9.424 9.424 0 0 0 3.75 15c0 .488.038.994.112 1.462L.694 18.938a.775.775 0 0 0-.188.956l3 5.194c.188.337.582.45.919.337l3.731-1.5c.788.6 1.613 1.087 2.531 1.462l.563 3.976c.075.375.375.637.75.637h6c.375 0 .694-.262.731-.637l.563-3.976a11.279 11.279 0 0 0 2.531-1.462l3.731 1.5c.338.131.732 0 .919-.338l3-5.193c.188-.338.112-.731-.188-.956l-3.13-2.476zM15 20.625c-3.094 0-5.625-2.531-5.625-5.625S11.906 9.375 15 9.375s5.625 2.531 5.625 5.625-2.531 5.625-5.625 5.625z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingIconBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/setting-icon-blue.3653c52c449e11ced0d195d73ed0c22c.svg";